class RecaptchaService {
    constructor() {
        this.script = "";
    }

    execute() {
        window.grecaptcha.reset();
        window.grecaptcha.execute();
    }

    load(callback) {
        this.script = document.createElement("script");
        this.script.src =
            "https://www.google.com/recaptcha/api.js?onload=onloadRecaptchaCallback&render=explicit";
        this.script.async = true;
        this.script.defer = true;
        this.script.dataset.name = "recaptcha-service";

        document.getElementsByTagName("head")[0].appendChild(this.script);

        window.onloadRecaptchaCallback = () => {
            window.grecaptcha.render("recaptcha_element", {
                sitekey: "6LeRgPAdAAAAAL2bM_lxpqfTO7_D3T50BbV4_gau",
                callback: typeof callback === "function" ? callback : "",
            });
        };
    }

    destroy() {
        document.getElementsByTagName("head")[0].removeChild(this.script);
    }
}

export const recaptchaService = new RecaptchaService();
